// extracted by mini-css-extract-plugin
export default {"orderDetails":"style--orderDetails--200728","info":"style--info--41388e","downloadPdf":"style--downloadPdf--c7237f","label":"style--label--57b4f5","value":"style--value--372ae1"};